import { atom, selector } from 'recoil';
import type { ProductParameterType, ProductParameterTypes } from '../../@sprinx/knihovka-types/products';
import { ApiClient } from '../../@sprinx/react-after-razzle';
import { GlobalStateRegister } from '../../@sprinx/react-after-razzle/stateStore';
import { apiClientState } from '../appState';

export type ProductParameterTypesHandler = () => Promise<ProductParameterTypes>;

export type ProductParameterTypesWithValueCounts = ProductParameterType & {
  valueCounts: { count: number; value: string }[];
};

export type ProductParameterTypesWithValueCountsHandler = () => Promise<ProductParameterTypesWithValueCounts[]>;

export function getProductParameterTypesWithValueCounts(
  apiClient: ApiClient,
  mainTaxonomy: string,
  variantsIncluded?: boolean,
): ReturnType<ProductParameterTypesWithValueCountsHandler> {
  return apiClient.get<ProductParameterTypesWithValueCounts[], {}>('/v1/product-parameter-types-with-value-counts', {
    mainTaxonomy,
    variantsIncluded,
  });
}

export function getProductParameterTypes(apiClient: ApiClient): ReturnType<ProductParameterTypesHandler> {
  return apiClient.get<ProductParameterTypes, {}>('/v1/product-parameter-types', {});
}

export const productParameterTypesInitialState = GlobalStateRegister.register(
  atom<ProductParameterTypes | undefined>({
    key: 'productParameterTypesInitial',
    default: undefined,
  }),
);

export const productParameterTypesQuery = selector<ProductParameterTypes>({
  key: 'productParameterTypes',
  get: ({ get }) => {
    const initial = get(productParameterTypesInitialState);
    if (initial) return initial;

    const apiClient = get(apiClientState);
    return getProductParameterTypes(apiClient);
  },
});
